import React, { useState, useRef } from 'react';
import { Form, Spin, message } from 'antd';
import MaskedInput from 'antd-mask-input';
import * as S from './styles';
import api from '../../services/api';
import { RightTab } from './Tabs/rightTab';
import { LeftTab } from './Tabs/leftTab';
import { Banner } from './Banner/banner';

export default function PortalInformacoes() {
  const [form] = Form.useForm();
  const [spinning, setSpinning] = useState(false);
  const [active, setActive] = useState(false);
  const [dataScreen, setDataScreen] = useState([]);
  const ref = useRef();

  const consultarCPF = async e => {
    const { cpf } = e;
    const cpfSemPontos = cpf.replaceAll('.', '').replace('-', '');
    if (cpf.includes('_')) {
      ref.current.focus();
      return message.error('O CPF deve conter 11 números');
    }
    setDataScreen([]);
    setActive(false);
    setSpinning(true);
    try {
      const response = await api.get(`/PortalInformacoes?cpf=${cpfSemPontos}`);
      if (response.status !== 200 || response.data.cpfMotorista === null) {
        setSpinning(false);
        return message.error('O CPF consultado não retornou nenhum dado.');
      }
      setDataScreen(response?.data);
      setActive(true);
      setSpinning(false);
    } catch (error) {
      message.error(
        error?.response?.data?.detail ||
          'O CPF consultado não retornou nenhum dado.'
      );
      setSpinning(false);
    }
  };

  return (
    <S.Wrapper id="wrapper">
      <Spin
        spinning={spinning}
        size="large"
        description="Carregando o Portal de informações!"
      >
        <S.BannerArea>
          <Banner />
        </S.BannerArea>

        <S.Card as="section" aria-label="Consulta de motorista">
          <Form name="form" form={form} onFinish={consultarCPF}>
            <S.SearchRow>
              <S.SearchField>
                <S.Text>Insira o CPF que deseja consultar:</S.Text>
                <S.CpfFormItem
                  name="cpf"
                  rules={[
                    {
                      required: true,
                      message: 'Insira um CPF válido.',
                    },
                  ]}
                >
                  <MaskedInput
                    required
                    mask="000.000.000-00"
                    title="CPF deve conter 11 caracteres."
                    pattern=".{14,14}"
                    inputMode="numeric"
                    autoComplete="off"
                    ref={ref}
                  />
                </S.CpfFormItem>
              </S.SearchField>
              <S.SubmitFormItem>
                <S.PrimaryButton
                  htmlType="submit"
                  type="primary"
                  size="large"
                  loading={spinning}
                >
                  Consultar
                </S.PrimaryButton>
              </S.SubmitFormItem>
            </S.SearchRow>
          </Form>
        </S.Card>

        {active ? (
          <S.ResultsGrid
            $singleColumn={dataScreen.codigoStatusMotorista === 3}
            aria-live="polite"
          >
            <S.Fundo id="fundo" active={active}>
              <LeftTab dataScreen={dataScreen} />
            </S.Fundo>
            {dataScreen.codigoStatusMotorista !== 3 && (
              <S.Fundo id="fundo" active={active}>
                <RightTab dataScreen={dataScreen} />
              </S.Fundo>
            )}
          </S.ResultsGrid>
        ) : (
          <S.EmptyCard aria-live="polite">
            <S.DivDisplayFlex>
              <S.StartMessageH1>
                Busque pelo CPF do motorista no campo acima
              </S.StartMessageH1>
              <S.StartMessageP>
                Assim você encontrará o histórico do motorista que estiver em
                nosso banco de dados e de parceiros.
              </S.StartMessageP>
            </S.DivDisplayFlex>
          </S.EmptyCard>
        )}
      </Spin>

      <S.FooterArea>
        <S.Card>
          <S.TextFooter>
            O portal de informações TMOV não fornece referência e não é uma
            recomendação de motoristas. O portal de informação se trata de
            informações sobre o histórico de viagem dos motoristas que servem
            para auxiliar a tomada de decisão das transportadoras parceiras.
          </S.TextFooter>
        </S.Card>
      </S.FooterArea>
    </S.Wrapper>
  );
}
